<div class="container-fluid">
  <div class="row mt-4" *ngIf="!isReducedView">
    <div class="col">
      <h4 class="text-uppercase">{{isRCDSS ? 'New Simple Contract' : 'New Simple Purchase Order'}}  <span
        *ngIf="purchaseOrder?.customer_po_number"># {{ purchaseOrder.customer_po_number }}</span>
      </h4>
    </div>
  </div>

  <div [formGroup]="purchaseOrderForm">
        <div class="row">
          <div [ngClass]="{
            'col-md-12': isReducedView,
            'col-md-5': !isReducedView
          }">

            <div class="row">
              <div class="col">
                <mat-form-field>
                  <input type="text" matInput
                         [placeholder]="isRCDSS ? 'Contract number' : 'Purchase Order / Contract number'"
                         formControlName="customer_po_number"
                         required />
                  <mat-error *ngIf="purchaseOrderForm.controls.customer_po_number.errors?.exists">
                    This number is already registered
                  </mat-error>
                  <mat-error *ngIf="!purchaseOrderForm.controls.customer_po_number.value">
                    This field is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <ng-select
                  ngEditableSelect
                  labelForId="supplier_select"
                  #supplier_select
                  [items]="suppliers"
                  bindValue="id"
                  bindLabel="name"
                  placeholder="Supplier *"
                  required
                  appendTo="body"
                  [clearable]="false"
                  [minlength]="2"
                  typeToSearchText="Please enter 2 or more characters"
                  formControlName="supplier_id"
                >
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div [ngOptionHighlight]="search">
                      {{ item.name }}
                    </div>
                  </ng-template>
                  <ng-template ng-footer-tmp>
                    <a class="d-block" (click)="addNewCompany(); supplier_select.close();">
                      Add new company
                    </a>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-12" *ngIf="isSimpleFlow && !isReducedView">
                <mat-form-field>
                  <mat-select placeholder="Approver"
                              formControlName="approver_id"
                              matTooltip="Picking 'No Approver' will create the {{isRCDSS? 'Contract':'Purchase Order'}} in an Open status, therefore your supplier will not need to approve it and will not receive the approval email notification."
                              [disabled]="!purchaseOrderForm.controls.supplier_id.value">
                    <mat-option value="00000000-0000-0000-0000-000000000000">No Approver</mat-option>
                    <mat-option *ngFor="let user of supplierUsers"
                                [value]="user.id">{{ user.first_name }} {{ user.last_name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative" *ngIf="!isReducedView">
          <button class="ml-1 mr-1" type="button" mat-raised-button color="grey" (click)="savePODraft(true)"
                  [disabled]="isSaving || !canSupplierReceivePos || !purchaseOrder">
            Save to Draft
          </button>
          <button class="ml-1 mr-1" type="button" mat-raised-button color="primary"
                  [disabled]="isSaving || !canSupplierReceivePos"
                  (click)="createPO()">
            {{ isReducedView ? 'Create and Send' : 'Send to Supplier'}}
          </button>

          <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
                  (click)="deletePoDraft()">
            <i class="fa fa-trash"></i>
            {{isRCDSS ? 'Discard Contract' : 'Discard PO'}}
          </button>
        </div>

  </div>

</div>
